import { getListViewStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

// Mutator action to set shouldShowAutomaticRepliesBanner
export default mutatorAction(
    'setShouldShowAutomaticRepliesBanner',
    function setShouldShowAutomaticRepliesBanner(shouldShowAutomaticRepliesBanner: boolean) {
        getListViewStore().shouldShowAutomaticRepliesBanner = shouldShowAutomaticRepliesBanner;
    }
);
